<template>
  <div>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
        Email Settings</v-toolbar-title>
    </v-toolbar>
    <v-card min-height="calc(100vh - 80px)" class="email-setting">
      <v-card-text :loading="isLoading">
        <div class="grid-wrapper">
          <div class="inputWrapper">
            <label for="smtpHost" class="label">SMTP Host:</label>
            <v-text-field outlined dense id="smtpHost" v-model="emailSettings.host" required />
          </div>
          <div class="inputWrapper">
            <label for="smtpPort" class="label">SMTP Port:</label>
            <v-text-field outlined dense id="smtpPort" v-model="emailSettings.port" required />
          </div>
          <div class="inputWrapper">
            <label for="smtpUsername" class="label">SMTP Username:</label>
            <v-text-field outlined dense id="smtpUsername" v-model="emailSettings.userName" required />
          </div>
          <div class="inputWrapper passwordInput">
            <label for="smtpPassword" class="label">SMTP Password:</label>
            <v-text-field outlined dense type="password" id="smtpPassword" v-model="emailSettings.password" required />
          </div>
          <div class="inputWrapper">
            <label for="smtpEncription" class="label">SMTP Encryption:</label>
            <v-text-field outlined dense id="smtpEncription" readonly v-model="emailSettings.protocol" required />
          </div>
          <div class="inputWrapper">
            <label for="from" class="label">From:</label>
            <v-text-field outlined dense id="from"v-model="emailSettings.from" required />
          </div>
        </div>
        <div class="line-wrapper">
          <div align="center">
            <v-btn @click="isDisplayDialog = !isDisplayDialog" dark color="#ff8a25">Test Settings</v-btn>
            <v-btn @click="saveEmailSettings" style="margin: 0 0 0 20px" color="bg-primary" dark>Save</v-btn>
          </div>
        </div>
        <v-dialog v-model="isDisplayDialog" max-width="600">
          <v-card>
            <v-toolbar color="#28a2ff" dark height="50px" min-height="50px">
              <v-toolbar-title>
                <div>Test email settings</div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon small @click="isDisplayDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <div>
                <v-row style="margin-top: 25px">
                  <v-col>
                    <div class="inputWrapper">
                      <label for="emailSubject" class="label">Send to:</label>
                      <v-text-field outlined dense id="emailSubject" v-model="email.sendTo" required />
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="inputWrapper">
                      <label for="emailSubject" class="label">Subject:</label>
                      <v-text-field outlined dense id="emailSubject" v-model="email.subject" />
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div class="inputWrapper">
                      <label for="emailText" class="label">Text:</label>
                      <v-textarea outlined dense id="emailText" v-model="email.text" />
                    </div>
                  </v-col>
                </v-row>
                <div style="text-align: center" class="py-3">
                  <v-btn class="mx-1" @click="sendTestEmail" color="primary">
                    Send
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import RestService from '@/services/rest.service'
import axios from 'axios'
export default {
  name: 'MailSettings',
  data: () => ({
    emailSettings: {},
    email: {
      sendTo: '',
      subject: '',
      text: ''
    },
    isDisplayDialog: false,
    isLoading: false
  }),
  created() {
    this.initializeEmailSettings()
  },
  methods: {
    initializeEmailSettings: async function () {
      this.isLoading = true
      RestService.post(process.env.VUE_APP_APIURL + 'emailsettings', {})
        .then(({ data }) => {
          this.isLoading = false
          this.emailSettings = data
        },
          (e) => {
            this.error = e.message
            console.log('domains/update_status', e)
          })
    },
    saveEmailSettings: async function () {
      this.isLoading = true
      RestService.post(process.env.VUE_APP_APIURL + 'emailsettings/update', JSON.stringify(this.emailSettings))
        .then((response) => {
          if (response.data.result) {
            Vue.notify({
              title: 'Success',
              text: 'Email settings updated successful'
            })
          } else {
            Vue.notify({
              title: 'Error',
              text: 'Error on update email settings',
              type: 'error'
            })
          }
          this.isLoading = false
        },
          (e) => {
            this.error = e.message
            console.log('emailsettings/update', e)
          })
    },
    sendTestEmail: async function () {
      this.isLoading = true
      function validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }
      
      if (this.email.sendTo == "") {
        return Vue.notify({
          title: 'Invalid Email Address',
          text: 'Please input sendTo email address!',
          type: 'warn'
        })
      }
      if (validateEmail(this.email.sendTo) == false) {
        return Vue.notify({
          title: 'Invalid Email Address',
          text: 'Please input correct sendTo email address!',
          type: 'warn'
        })
      }
      if (this.email.subject == "") {
        return Vue.notify({
          title: 'Invalid subject',
          text: 'Please input Subject!',
          type: 'warn'
        })
      }
      if (this.email.text == "") {
        return Vue.notify({
          title: 'Invalid text',
          text: 'Please input any Text!',
          type: 'warn'
        })
      }


      RestService.post(process.env.VUE_APP_APIURL + 'emailsettings/sendtestemail', JSON.stringify(this.email))
        .then((response) => {
          if (response.data.result) {
            Vue.notify({
              title: 'Email sent successful',
              text: 'Email sent to ' + this.email.sendTo
            })
          } else {
            Vue.notify({
              title: 'Error on sent email',
              text: 'Error on sent email to ' + this.email.sendTo,
              type: 'error'
            })
          }
          this.email.text = ''
          this.email.sendTo = ''
          this.email.subject = ''
          this.isLoading = false
          this.isDisplayDialog = false

        },
          (e) => {
            this.error = e.message
            console.log('emailsettings/sendtestemail', e)
          })

    }
  }
}
</script>

<style lang="scss">
.email-setting {
  .grid-wrapper {
    max-width: 900px;
    color: gray;
    margin: 50px auto !important;
    /* height: 620px; */
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 30px;
    
    @media only screen and (max-width: 600px) {
      grid-template-columns: auto;
    }
  }

  .line-wrapper {
    max-width: 900px;
    color: gray;
    margin: 50px auto !important;
  }

  .inputWrapper {
    display: flex;
    flex-direction: column;
  }

  .label {
    margin-bottom: 10px;
  }

}
</style>
